<div
  *ngIf="!isLoading; else skeleton"
  class="p-d-flex p-flex-column paket-menu-wrapper"
>
  <div class="p-d-flex p-flex-row paketi-wrapper" style="width: 100%">
    <!-- Spisak paketa -->
    <div
      class="p-d-flex p-flex-column flex-2 spisak-paketa-wrapper"
      style="width: 100%"
    >
      <div class="paket-card p-p-3">
        <div class="izabrano-title p-mb-4">Osnovni paketi</div>

        <!-- Prvi paket Besplatno -->
        <kodit-package-box
          [label]="getLabel(PackageType.BESPLATNO)"
          [price]="getPrice(PackageType.BESPLATNO)"
          [priceLabel]="getPriceLabel(PackageType.BESPLATNO)"
          [packageId]="getPackageId(PackageType.BESPLATNO)"
          [packageType]="PackageType.BESPLATNO"
          [isDisabled]="disabledMainPackages.has(PackageType.BESPLATNO)"
          [isSelected]="isPackageSelected(PackageType.BESPLATNO)"
          [isMain]="true"
          (packageSelected)="handlePackageSelected($event)"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>

        <div class="package-divider"></div>

        <div class="p-d-flex p-jc-between gap-8">
          <!-- Drugi paket eFaktura -->
          <kodit-package-box
            [label]="getLabel(PackageType.EFAKTURE)"
            [price]="getPrice(PackageType.EFAKTURE)"
            [priceLabel]="getPriceLabel(PackageType.EFAKTURE)"
            [packageId]="getPackageId(PackageType.EFAKTURE)"
            [packageType]="PackageType.EFAKTURE"
            [isDisabled]="disabledMainPackages.has(PackageType.EFAKTURE)"
            [isSelected]="isPackageSelected(PackageType.EFAKTURE)"
            (packageSelected)="handlePackageSelected($event)"
            [isMain]="true"
            (packageUnselected)="handlePackageUnselected($event)"
            style="flex: 1"
          >
          </kodit-package-box>

          <!-- Treci paket Veleprodaja -->
          <kodit-package-box
            [label]="getLabel(PackageType.VELEPRODAJA)"
            [price]="getPrice(PackageType.VELEPRODAJA)"
            [priceLabel]="getPriceLabel(PackageType.VELEPRODAJA)"
            [packageId]="getPackageId(PackageType.VELEPRODAJA)"
            [packageType]="PackageType.VELEPRODAJA"
            [isDisabled]="disabledMainPackages.has(PackageType.VELEPRODAJA)"
            [isSelected]="isPackageSelected(PackageType.VELEPRODAJA)"
            (packageSelected)="handlePackageSelected($event)"
            [isMain]="true"
            (packageUnselected)="handlePackageUnselected($event)"
            style="flex: 1"
          >
          </kodit-package-box>
        </div>

        <div class="package-divider"></div>

        <div class="p-d-flex p-jc-between gap-8">
          <!-- Cetvrti paket Fiskalana kasa -->
          <kodit-package-box
            [label]="getLabel(PackageType.FISKALNA_KASA)"
            [price]="getPrice(PackageType.FISKALNA_KASA)"
            [priceLabel]="getPriceLabel(PackageType.FISKALNA_KASA)"
            [packageId]="getPackageId(PackageType.FISKALNA_KASA)"
            [packageType]="PackageType.FISKALNA_KASA"
            [isDisabled]="disabledMainPackages.has(PackageType.FISKALNA_KASA)"
            [isSelected]="isPackageSelected(PackageType.FISKALNA_KASA)"
            (packageSelected)="handlePackageSelected($event)"
            (packageUnselected)="handlePackageUnselected($event)"
            [isMain]="true"
            style="flex: 1"
          >
          </kodit-package-box>

          <!-- Peti paket Maloprodaja -->
          <kodit-package-box
            [label]="getLabel(PackageType.MALOPRODAJA)"
            [price]="getPrice(PackageType.MALOPRODAJA)"
            [priceLabel]="getPriceLabel(PackageType.MALOPRODAJA)"
            [packageId]="getPackageId(PackageType.MALOPRODAJA)"
            [packageType]="PackageType.MALOPRODAJA"
            [isDisabled]="disabledMainPackages.has(PackageType.MALOPRODAJA)"
            [isSelected]="isPackageSelected(PackageType.MALOPRODAJA)"
            (packageSelected)="handlePackageSelected($event)"
            [isMain]="true"
            (packageUnselected)="handlePackageUnselected($event)"
            style="flex: 1"
          >
          </kodit-package-box>
        </div>

        <div class="package-divider"></div>

        <!-- Sesti paket Arhiva i delovodnik -->
        <kodit-package-box
          [label]="getLabel(PackageType.ARHIVA)"
          [price]="getPrice(PackageType.ARHIVA)"
          [priceLabel]="getPriceLabel(PackageType.ARHIVA)"
          [packageId]="getPackageId(PackageType.ARHIVA)"
          [packageType]="PackageType.ARHIVA"
          [isDisabled]="disabledMainPackages.has(PackageType.ARHIVA)"
          [isSelected]="isPackageSelected(PackageType.ARHIVA)"
          (packageSelected)="handlePackageSelected($event)"
          [isMain]="true"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>

        <div class="package-divider"></div>

        <!-- Sedmi paket eOtpremnice -->
        <kodit-package-box
          [label]="getLabel(PackageType.EOTPREMNICE)"
          [price]="getPrice(PackageType.EOTPREMNICE)"
          [priceLabel]="getPriceLabel(PackageType.EOTPREMNICE)"
          [packageId]="getPackageId(PackageType.EOTPREMNICE)"
          [packageType]="PackageType.EOTPREMNICE"
          [isDisabled]="isEOtpremnicaUkljucenaUVeleprodaju()"
          [isSelected]="isPackageSelected(PackageType.EOTPREMNICE)"
          [priceOverrideText]="
            isEOtpremnicaUkljucenaUVeleprodaju() ? 'uključeno u VP' : undefined
          "
          (packageSelected)="handlePackageSelected($event)"
          [isMain]="true"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>
      </div>

      <div class="paket-card p-mt-4 p-p-3">
        <div class="izabrano-title">Dodaci</div>
        <div class="izabrano-subtitle">Dodatne funkcije osnovnih paketa</div>
        <!-- Dodatak: Korisnicki nalozi -->
        <kodit-package-box
          [label]="getLabel(PackageType.KORISNICKI_NALOG)"
          [price]="getPrice(PackageType.KORISNICKI_NALOG)"
          [priceLabel]="getPriceLabel(PackageType.KORISNICKI_NALOG)"
          [packageId]="getPackageId(PackageType.KORISNICKI_NALOG)"
          [packageType]="PackageType.KORISNICKI_NALOG"
          [showIncrementInput]="true"
          [isDisabled]="service.shouldDisableKorisnickiNaloziAddition"
          [incrementValue]="service.getForm().value.dodatniKorisnici"
          (packageSelected)="handlePackageSelected($event)"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>
        <!-- Dodatak: Prodajna mesta -->
        <kodit-package-box
          [label]="getLabel(PackageType.PRODAJNO_MESTO)"
          [price]="getPrice(PackageType.PRODAJNO_MESTO)"
          [priceLabel]="getPriceLabel(PackageType.PRODAJNO_MESTO)"
          [packageId]="getPackageId(PackageType.PRODAJNO_MESTO)"
          [packageType]="PackageType.PRODAJNO_MESTO"
          [showIncrementInput]="true"
          [isDisabled]="service.shouldDisableProdajnoMestoAddition"
          [incrementValue]="service.getForm().value.dodatnaProdajnaMesta"
          (packageSelected)="handlePackageSelected($event)"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>
        <!-- Dodatak: Proizvodnja -->
        <kodit-package-box
          [label]="getLabel(PackageType.PROIZVODNJA)"
          [price]="getPrice(PackageType.PROIZVODNJA)"
          [priceLabel]="getPriceLabel(PackageType.PROIZVODNJA)"
          [packageId]="getPackageId(PackageType.PROIZVODNJA)"
          [packageType]="PackageType.PROIZVODNJA"
          [showIncrementInput]="false"
          [isDisabled]="service.shouldDisableProizvodnjaAddition"
          [isSelected]="isPackageSelected(PackageType.PROIZVODNJA)"
          (packageSelected)="handlePackageSelected($event)"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>
        <!-- Dodatak: Finansije -->
        <kodit-package-box
          [label]="getLabel(PackageType.FINANSIJE)"
          [price]="getPrice(PackageType.FINANSIJE)"
          [priceLabel]="getPriceLabel(PackageType.FINANSIJE)"
          [packageId]="getPackageId(PackageType.FINANSIJE)"
          [packageType]="PackageType.FINANSIJE"
          [showIncrementInput]="false"
          [isDisabled]="service.shouldDisableFinansijeAddition"
          [isSelected]="isPackageSelected(PackageType.FINANSIJE)"
          (packageSelected)="handlePackageSelected($event)"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>
        <!-- Dodatak: eFakture API -->
        <kodit-package-box
          [label]="getLabel(PackageType.EFAKTURE_API)"
          [price]="getPrice(PackageType.EFAKTURE_API)"
          [priceLabel]="getPriceLabel(PackageType.EFAKTURE_API)"
          [packageId]="getPackageId(PackageType.EFAKTURE_API)"
          [packageType]="PackageType.EFAKTURE_API"
          [showIncrementInput]="false"
          [isDisabled]="true"
          [shouldDisablePrice]="!isPackageSelected(PackageType.EFAKTURE_API)"
          [isSelected]="isPackageSelected(PackageType.EFAKTURE_API)"
          (packageSelected)="handlePackageSelected($event)"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>
        <!-- Dodatak: eOtpremnice API -->
        <kodit-package-box
          [label]="getLabel(PackageType.EOTPREMNICE_API)"
          [price]="getPrice(PackageType.EOTPREMNICE_API)"
          [priceLabel]="getPriceLabel(PackageType.EOTPREMNICE_API)"
          [packageId]="getPackageId(PackageType.EOTPREMNICE_API)"
          [packageType]="PackageType.EOTPREMNICE_API"
          [showIncrementInput]="false"
          [isDisabled]="true"
          [shouldDisablePrice]="!isPackageSelected(PackageType.EOTPREMNICE_API)"
          [isSelected]="isPackageSelected(PackageType.EOTPREMNICE_API)"
          (packageSelected)="handlePackageSelected($event)"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>
        <!-- Dodatak: Fiskalna API -->
        <kodit-package-box
          [label]="getLabel(PackageType.FISKLANI_API)"
          [price]="getPrice(PackageType.FISKLANI_API)"
          [priceLabel]="getPriceLabel(PackageType.FISKLANI_API)"
          [packageId]="getPackageId(PackageType.FISKLANI_API)"
          [packageType]="PackageType.FISKLANI_API"
          [showIncrementInput]="false"
          [isDisabled]="true"
          [shouldDisablePrice]="!isPackageSelected(PackageType.FISKLANI_API)"
          [isSelected]="isPackageSelected(PackageType.FISKLANI_API)"
          (packageSelected)="handlePackageSelected($event)"
          (packageUnselected)="handlePackageUnselected($event)"
          style="flex: 1"
        >
        </kodit-package-box>
      </div>
    </div>

    <!-- Izabrani paketi -->
    <div class="p-d-flex flex-1 izabrani-paketi-wrapper p-flex-column">
      <!-- Header -->
      <div class="izabrani-header p-p-4">
        <div
          *ngIf="!shouldHideYearlySwitch"
          class="subscription-toggle-wrapper"
        >
          <span class="toggle-label">Mesečno</span>

          <p-inputSwitch
            [formControl]="service.getForm().controls.isYearly | formControl"
            [styleClass]="'subscription-toggle'"
          ></p-inputSwitch>

          <span class="toggle-label"
            >Godišnje <span class="toggle-discount">(-10%)</span></span
          >
        </div>
        <div class="izabrano-title">Izabrano</div>
        <div class="izabrano-subtitle">Vaše izabrane funkcije</div>
      </div>
      <!-- fiksno -->
      <div
        *ngIf="service.hasPackagesForFixed()"
        class="p-d-flex p-flex-column p-p-4 flex-1 izabrani-paketi-sub-wrapper"
      >
        <div class="izabrano-title p-mb-2">Fiksne pretplate</div>
        <div
          *ngFor="let pkg of service.getPackagesForFixedTotal"
          class="p-d-flex p-flex-row p-jc-between p-ai-center p-mb-4"
        >
          <div
            class="selected-item-title"
            [ngClass]="{ bold: !pkg.isAddition }"
          >
            {{
              pkg.packageType === PackageType.BESPLATNO ? pkg.label : pkg.label
            }}
          </div>
          <div
            *ngIf="service.jeEOtpremnicaUkljucenaUVeleprodaju(pkg); else cenaPaketa"
            class="selected-item-price"
          >
            <span>uključeno u VP</span>
          </div>
          <ng-template #cenaPaketa>
            <div class="selected-item-price">
              <span class="price">{{ pkg.price | number: '1.0-0' }}</span>
              <span> {{ pkg.priceLabel }}</span>
            </div>
          </ng-template>
        </div>
        <ng-container [ngTemplateOutlet]="freeSeats"></ng-container>

        <!-- Ukupna cena -->
        <div *ngIf="!isYearly" class="p-d-flex p-flex-column">
          <div
            *ngIf="service.getPackages.value.length > 0"
            class="horizontal-break-line"
          ></div>
          <div class="p-d-flex p-flex-row p-jc-between p-ai-center">
            <div class="total-title">Ukupno</div>
            <div class="total-price">
              {{ getMonthlyPrice() | number: '1.0-0' }}
              <span class="total-rsd">RSD / mesečno</span>
            </div>
          </div>
          <div
            *ngIf="service.hasYearlyPackages()"
            class="p-d-flex p-justify-end p-ai-center"
          >
            <div class="total-price">
              {{ getOnlyYearlyPrice() | number: '1.0-0' }}
              <span class="total-rsd">RSD / godišnje</span>
            </div>
          </div>
        </div>
        <div *ngIf="isYearly" class="p-d-flex p-flex-column">
          <div
            *ngIf="service.getPackages.value.length > 0"
            class="horizontal-break-line"
          ></div>
          <div class="p-d-flex p-flex-row p-jc-between p-ai-center">
            <div class="total-title">Ukupno</div>
            <div class="total-price">
              {{ getYearlyPrice() | number: '1.0-0' }}
              <span class="total-rsd">RSD / godišnje</span>
            </div>
          </div>
        </div>
      </div>
      <!-- po potrosnji -->
      <div
        *ngIf="service.hasPackagesForUsage()"
        class="p-d-flex p-flex-column p-p-4 flex-1 izabrani-paketi-sub-wrapper"
      >
        <div class="izabrano-title">Naplate po potrošnji</div>

        <div
          *ngFor="let pkg of service.getPackagesForUsageTotal"
          class="p-d-flex p-flex-row p-jc-between p-ai-center p-mb-4"
        >
          <div class="selected-item-title">
            {{ pkg.label }}
          </div>
          <div class="selected-item-price">
            <span class="price">{{ pkg.price | number: '1.0-0' }}</span>
            <span> {{ pkg.priceLabel }}</span>
          </div>
        </div>

        <p-messages severity="info">
          <ng-template pTemplate>
            <div class="p-d-flex p-jc-between" style="width: 100%">
              <div class="p-d-flex p-flex-column p-jc-center gap-6">
                <div>
                  Naplate po potrošnji se obračunavaju na kraju meseca prema
                  stvarnoj upotrebi.
                </div>
              </div>
              <div class="p-d-flex p-ai-center p-jc-center">
                <span
                  class="p-message-icon pi pi-info-circle"
                  style="font-size: 2.5rem"
                ></span>
              </div>
            </div>
          </ng-template>
        </p-messages>
      </div>
      <!-- dugme za potvrdu i ugovor -->
      <div
        *ngIf="
          (service.hasPackagesForUsage() || service.hasPackagesForFixed()) &&
          jeNadogradnja
        "
        class="p-d-flex p-flex-column p-p-5 p-align-end"
      >
        <kodit-button
          btnLabel="Dalje"
          class="p-mt-3"
          (btnClicked)="openUsloviDialog()"
        ></kodit-button>
      </div>
      <!-- prazno -->
      <div
        *ngIf="!service.hasPackagesForUsage() && !service.hasPackagesForFixed()"
        class="p-d-flex p-ai-center p-jc-center flex-1"
      >
        <div class="p-d-flex p-flex-column p-jc-center p-ai-center gap-12">
          <img
            src="../../../assets/empty-cart.png"
            alt="emplty-cart"
            [width]="100"
            [height]="100"
          />
          <div class="izabrano-subtitle">Nema odabranih paketa</div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #freeSeats>
  <div class="p-d-flex p-flex-row p-jc-between p-ai-center p-mb-4">
    <div class="selected-item-title">
      Korisnički nalozi ({{ freeSeatsCount }})
    </div>
    <div class="selected-item-price">
      <span class="price">Besplatno</span>
    </div>
  </div>
</ng-template>

<ng-template #skeleton>
  <div class="p-d-flex p-flex-column paket-menu-wrapper">
    <div class="p-d-flex p-flex-row paketi-wrapper" style="width: 100%">
      <!-- Spisak paketa -->
      <div
        class="p-d-flex p-flex-column flex-2 spisak-paketa-wrapper"
        style="width: 100%"
      >
        <div class="paket-card p-mt-4 p-p-3">
          <div
            class="p-d-flex p-flex-row p-ai-center p-jc-between"
            style="width: 100%"
          >
            <!-- Prvi paket Besplatno -->
            <div class="skeleton-wrapper">
              <div class="skeleton-bar w30"></div>
              <div class="skeleton-bar w30"></div>
            </div>
          </div>
        </div>

        <div class="paket-card p-mt-4 p-p-3">
          <div
            class="p-d-flex p-flex-row p-ai-center p-jc-between"
            style="width: 100%"
          >
            <!-- Drugi paket eFaktura -->

            <div class="skeleton-wrapper border">
              <div class="skeleton-bar w30"></div>
              <div class="skeleton-bar w70"></div>
            </div>

            <span class="p-mx-2" style="white-space: nowrap">ili</span>

            <!-- Treci paket Veleprodaja -->
            <div class="skeleton-wrapper border">
              <div class="skeleton-bar w30"></div>
              <div class="skeleton-bar w70"></div>
            </div>
          </div>

          <!-- DODACI eFakture i Veleprodaja -->
          <div class="p-mt-4 p-d-flex p-flex-column">
            <div class="skeleton-wrapper">
              <div class="skeleton-bar w50"></div>
              <div class="skeleton-bar w30"></div>
            </div>
            <div class="skeleton-wrapper p-mt-3">
              <div class="skeleton-bar w50"></div>
              <div class="skeleton-bar w30"></div>
            </div>
            <div class="skeleton-wrapper p-mt-3">
              <div class="skeleton-bar w50"></div>
              <div class="skeleton-bar w30"></div>
            </div>
            <div class="skeleton-wrapper p-mt-3">
              <div class="skeleton-bar w50"></div>
              <div class="skeleton-bar w30"></div>
            </div>
          </div>
        </div>

        <div class="paket-card p-mt-4 p-p-3">
          <div
            class="p-d-flex p-flex-row p-ai-center p-jc-between"
            style="width: 100%"
          >
            <!-- Drugi paket eFaktura -->

            <div class="skeleton-wrapper border">
              <div class="skeleton-bar w30"></div>
              <div class="skeleton-bar w70"></div>
            </div>

            <span class="p-mx-2" style="white-space: nowrap">ili</span>

            <!-- Treci paket Veleprodaja -->
            <div class="skeleton-wrapper border">
              <div class="skeleton-bar w30"></div>
              <div class="skeleton-bar w70"></div>
            </div>
          </div>

          <!-- DODACI eFakture i Veleprodaja -->
          <div class="p-mt-4 p-d-flex p-flex-column">
            <div class="skeleton-wrapper">
              <div class="skeleton-bar w50"></div>
              <div class="skeleton-bar w30"></div>
            </div>
            <div class="skeleton-wrapper p-mt-3">
              <div class="skeleton-bar w50"></div>
              <div class="skeleton-bar w30"></div>
            </div>
          </div>
        </div>

        <div class="paket-card p-mt-4 p-p-3">
          <div
            class="p-d-flex p-flex-row p-ai-center p-jc-between"
            style="width: 100%"
          >
            <!-- Sesti paket Arhiva i delovodnik -->
            <div class="skeleton-wrapper p-mt-3">
              <div class="skeleton-bar w30"></div>
              <div class="skeleton-bar w30"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Izabrani paketi -->
      <div class="p-d-flex flex-1 izabrani-paketi-wrapper p-flex-column">
        <!-- Header -->
        <div class="izabrani-header p-p-4">
          <div class="subscription-toggle-wrapper">
            <div class="skeleton-wrapper end">
              <div class="skeleton-bar w30" style="height: 2rem"></div>
            </div>
          </div>
          <div class="skeleton-wrapper">
            <div class="skeleton-bar w30"></div>
          </div>
          <div class="skeleton-wrapper">
            <div class="skeleton-bar w30"></div>
          </div>
        </div>
        <!-- prazno -->
        <div
          *ngIf="
            !service.hasPackagesForUsage() && !service.hasPackagesForFixed()
          "
          class="p-d-flex p-ai-center p-jc-center flex-1"
        >
          <div class="p-d-flex p-flex-column p-jc-center p-ai-center gap-12">
            <img
              src="../../../assets/empty-cart.png"
              alt="emplty-cart"
              [width]="100"
              [height]="100"
            />
            <div class="izabrano-subtitle">Nema odabranih paketa</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
